import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export function BlogPostPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to Substack
    window.location.href = 'http://calculatedmoves.substack.com';
  }, []);

  return (
    <div className="min-h-screen bg-background-dark py-8">
      <div className="max-w-3xl mx-auto px-4">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-white mb-4">Redirecting to Substack...</h1>
        </div>
      </div>
    </div>
  );
}
